import { observer } from 'mobx-react';
import { FunctionComponent } from 'react';
import { useStores } from '../../Hooks';
import './index.scss';

const GlobalLoadingContainer: FunctionComponent = observer(() => {
    const { loadingStore } = useStores();
    return (
        <div className={`GlobalLoadingContainer ${loadingStore.isLoading() ? 'loading' : ''}`}>
            {loadingStore.isLoading() && (
                <div>
                    <div>
                        <svg
                            width="52"
                            height="52"
                            viewBox="0 0 24 24"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                className="spinner"
                                fill="white"
                                d="M2,12A10.94,10.94,0,0,1,5,4.65c-.21-.19-.42-.36-.62-.55h0A11,11,0,0,0,12,23c.34,0,.67,0,1-.05C6,23,2,17.74,2,12Z"
                            />
                        </svg>
                    </div>
                </div>
            )}
        </div>
    );
});

export default GlobalLoadingContainer;
